// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3FHit","choiceBoxes":"toolbarselects_choiceBoxes__ljfdy","simpleField":"toolbarselects_simpleField__t4PR1"};